import React from "react";
import Home from "../components/Home";

const HomeRoute = () => {
  return <Home />;
};

export default HomeRoute;
